import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'paycode';

class PayCodeService {
    getPayCodes() {
        return axios.get(API_URL, {headers: authHeader() });
    }
    create(paycode) {
      return axios
          .post(API_URL+ '/test', {
              code: paycode.code,
              title: paycode.title,
              use: paycode.use,
              isTest: paycode.isTest
          }, {headers: authHeader() });
    }
    updatePayCode(paycode){
        return axios.put(API_URL + '/' + paycode._id, {
            use: paycode.use
        }, {headers: authHeader() })
    }
}

export default new PayCodeService();